import { render, staticRenderFns } from "./Riclists.vue?vue&type=template&id=8744ee9c&"
import script from "./Riclists.vue?vue&type=script&lang=js&"
export * from "./Riclists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports